import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@emotion/react';

import { redirectToUrl } from '@gumtree/shared/src/util/browser-service';
import { trackGA4PreNav } from '@gumtree/shared/src/util/ga4-shared';
import { getNonFalsyUrlSearchParams } from '@gumtree/shared/src/util/url-params';

import SortSVG from '@gumtree/ui-library/src/icon/svg/sort-icon.svg';

import { CUSTOM_FILTERS } from '../shared/constants';
import { setSingleFilterState } from '../../reducers/current-filter-states';

import { Desktop, Mobile, SmallMobile, sortSelectorCss } from './styles';
import Select from '../filters/select';
import { SrpState } from '../../reducers';

export const SortSelector = () => {
    const dispatch = useDispatch();
    const theme = useTheme();

    const {
        resultsPage: { currentFilterStates, sortFilter },
    } = useSelector((data: SrpState): SrpState => data);

    const onChange = ({
        value,
        event: _,
        eventLabel: __,
        label,
    }: {
        value: string;
        event: string;
        eventLabel: string;
        label: string;
    }) => {
        dispatch(setSingleFilterState({ key: CUSTOM_FILTERS.SORT, value }));

        const searchLink = `/search?${getNonFalsyUrlSearchParams({
            ...currentFilterStates,
            [CUSTOM_FILTERS.SORT]: value,
        })}`;

        trackGA4PreNav<GA4.SortSearchResultsEvent>({
            event: 'sort_search_results',
            linkDomain: window.location.host,
            linkURL: searchLink,
            linkText: label,
        });
        redirectToUrl(searchLink);
    };

    const transformedOptions: {
        value: string;
        label: string;
        event: string;
        eventLabel: string;
    }[] = sortFilter.map((filter) => ({
        value: filter.value,
        label: filter.displayValue,
        event: 'SRP-sort-search',
        eventLabel: filter.value,
    }));

    const sortValue = currentFilterStates[CUSTOM_FILTERS.SORT] || transformedOptions[0].value;

    return (
        <Select
            id="select-sort-result"
            value={
                transformedOptions.find(({ value }) => value === sortValue) || transformedOptions[0]
            }
            options={transformedOptions}
            onChange={onChange}
            isSearchable={false}
            css={sortSelectorCss(theme)}
            getCustomSingleValue={(label) => (
                <>
                    <SmallMobile>Sort</SmallMobile>
                    <Mobile>
                        <SortSVG />
                        Sort
                    </Mobile>
                    <Desktop>{label}</Desktop>
                </>
            )}
        />
    );
};
